<template>
  <div class="tit">
    <i class="el-icon-right"></i>
    <h1>{{title}}</h1>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.tit {
  display: flex;
  align-items: center;
  font-size: 30px;
  i {
    color: #ff9c7a;
  }
  h1 {
    margin-left: 20px;
    color: #3b3b3b;
    font-weight: 800;
  }
}
</style>